var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"id":"PagoPluxBtn","x-large":"","color":"success"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-credit-card-outline")]),_vm._v(" Pagar con Tarjeta ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }